import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../assets/css/home.css';
import profileImage from '../assets/images/moi.jpeg';
import defaultImage from '../assets/images/raven3.png';

const Home = () => {
  const metaImage = `${window.location.origin}${defaultImage}`;
  
  return (
    <div id="home" className="content">
      <Helmet>
        <title>Fayaz Notes - Avid Fayaz</title>
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Fayaz Notes - Avid Fayaz" />
        <meta property="og:description" content="The personal website of Avid Fayaz" />
        <meta property="og:image" content={metaImage} />
        <meta property="og:url" content="https://www.avidfayaz.com" />
        <meta property="og:site_name" content="Fayaz Notes" />
      </Helmet>
    <div className="text-container">
      <h2>The personal website of Avid Fayaz</h2>
      <div className="links-container">
        <Link to="/about" className="link-box">
          <h3>About</h3>
          <p>General background, projects, and interests </p>
        </Link>
        <Link to="/writings" className="link-box">
          <h3>Writings</h3>
          <p>Personal blog and writings on various subjects and interests</p>
        </Link>
        <Link to="/podcasts" className="link-box">
          <h3>Podcasts</h3>
          <p>Listen to podcasts, covering a range of subjects and interviews</p>
        </Link>
        <Link to="/contact" className="link-box">
          <h3>Contact</h3>
          <p>Get in touch for inquiries, or just to say hi</p>
        </Link>
      </div>
    </div>
    <div className="image-container">
      <img src={profileImage} alt="Avid Fayaz" className="profile-image"/>
    </div>
  </div>
  );
};

export default Home;
